import axios from 'axios';
import { decodeHTML } from '../utils';

const WP_API_URL = 'https://admin.ninjascode.com/wp-json/wp/v2';



// Fetch all posts
export const fetchPosts = async (page) => {
  const postsPerPage = 9;
  try {
    const response = await axios.get(
      `${WP_API_URL}/posts?per_page=${postsPerPage}&page=${page}&_embed`
    );
    const totalPosts = parseInt(response.headers['x-wp-total'], 10);

    const posts = response.data.map(post => ({
      ...post,
      title: {
        ...post.title,
        rendered: decodeHTML(post.title.rendered), // Decode the title
      },
    }));

    return { posts, totalPosts };
  } catch (error) {
    console.error('Error fetching posts:', error);
    return { posts: [], totalPosts: 0 };
  }
};

// Fetch categories
// Fetch categories (limit to 6)
export const fetchCategories = async () => {
    try {
      const response = await axios.get(`${WP_API_URL}/categories?per_page=6`);
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  };
  

// Fetch posts by category (limit to 4 posts per category)
export const fetchPostsByCategory = async (categoryId) => {
    const postsPerPage = 4;
    try {
      const response = await axios.get(
        `${WP_API_URL}/posts?per_page=${postsPerPage}&categories=${categoryId}&_embed`
      );
      return { posts: response.data };
    } catch (error) {
      console.error(`Error fetching posts for category ${categoryId}:`, error);
      return { posts: [] };
    }
  };

  // Search posts by title
  export const searchPosts = async (query) => {
    try {
      const response = await axios.get(
        `${WP_API_URL}/posts?search=${query}&_embed`
      );
      return { posts: response.data };
    } catch (error) {
      console.error("Error searching posts:", error);
      return { posts: [] };
    }
  };
  
  
// Fetch a single post by slug
export const fetchPostBySlug = async (slug) => {
    const response = await axios.get(`${WP_API_URL}/posts?slug=${slug}&_embed`);
    return response.data[0]; // Return the first matching post
  };

  // Fetch recent posts by author
export const fetchRecentPostsByAuthor = async (authorId) => {
  const postsPerPage = 3;
  try {
    const response = await axios.get(
      `${WP_API_URL}/posts?per_page=${postsPerPage}&author=${authorId}&_embed`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching recent posts by author ${authorId}:`, error);
    return []; // Return an empty array in case of an error
  }
};

// Fetch paginated posts by category excluding the current blog
export const fetchPostsByCategoryExcludingSlugPaginated = async (categoryId, currentSlug, page, postsPerPage = 3) => {
  try {
    const response = await axios.get(
      `${WP_API_URL}/posts?per_page=${postsPerPage}&page=${page}&categories=${categoryId}&exclude=${currentSlug}&_embed`
    );
    const totalPosts = parseInt(response.headers['x-wp-total'], 10); // Get the total number of posts
    return { posts: response.data, totalPosts };
  } catch (error) {
    console.error(`Error fetching paginated posts for category ${categoryId}:`, error);
    return { posts: [], totalPosts: 0 }; // Return an empty array and zero totalPosts in case of an error
  }
};





